'use client';

import React, { useState } from 'react';

const segments = [
  { id: 'seg-all', label: 'All Markets', count: 34 },
  { id: 'seg-timepieces', label: 'Timepieces', count: 8 },
  { id: 'seg-art', label: 'Art', count: 7 },
  { id: 'seg-realestate', label: 'Real Estate', count: 6 },
  { id: 'seg-wine', label: 'Wine & Spirits', count: 5 },
  { id: 'seg-automobiles', label: 'Automobiles', count: 4 },
  { id: 'seg-jewellery', label: 'Jewellery', count: 4 },
];

const classifications = [
  { id: 'class-all', label: 'All Access Levels' },
  { id: 'class-confidential', label: 'Confidential' },
  { id: 'class-restricted', label: 'Restricted' },
  { id: 'class-general', label: 'General' },
];

interface IntelligenceFiltersProps {
  onSegmentChange?: (id: string) => void;
  onClassificationChange?: (id: string) => void;
}

export default function IntelligenceFilters({ onSegmentChange, onClassificationChange }: IntelligenceFiltersProps) {
  const [activeSegment, setActiveSegment] = useState('seg-all');
  const [activeClass, setActiveClass] = useState('class-all');

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-5">
        <h2 className="font-editorial text-xl font-semibold text-cream">
          Intelligence Reports
        </h2>
        <span className="text-xs text-muted-foreground tracking-widest uppercase">
          34 reports available
        </span>
      </div>

      {/* Market segments */}
      <div className="flex items-center gap-2 overflow-x-auto scroll-hidden pb-2 mb-4">
        {segments.map((seg) => {
          const isActive = activeSegment === seg.id;
          return (
            <button
              key={seg.id}
              onClick={() => {
                setActiveSegment(seg.id);
                onSegmentChange?.(seg.id);
              }}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-sm text-xs whitespace-nowrap transition-all duration-200 border ${
                isActive
                  ? 'category-pill-active border-transparent font-semibold' :'border-muted text-muted-foreground hover:text-cream hover:border-muted-foreground/50'
              }`}
            >
              <span>{seg.label}</span>
              <span className={`rounded-full px-1.5 py-0.5 text-xs ${isActive ? 'bg-obsidian/20 text-obsidian' : 'bg-muted/50'}`}>
                {seg.count}
              </span>
            </button>
          );
        })}
      </div>

      {/* Classification filter */}
      <div className="flex items-center gap-2">
        <span className="text-xs tracking-widest uppercase text-muted-foreground mr-2">Access:</span>
        {classifications.map((cls) => {
          const isActive = activeClass === cls.id;
          return (
            <button
              key={cls.id}
              onClick={() => {
                setActiveClass(cls.id);
                onClassificationChange?.(cls.id);
              }}
              className={`px-3 py-1 rounded-sm text-xs transition-all duration-200 ${
                isActive
                  ? cls.id === 'class-confidential' ?'classification-confidential'
                    : cls.id === 'class-restricted' ?'classification-restricted'
                    : cls.id === 'class-general' ?'classification-general' :'gold-gradient-bg text-obsidian font-semibold' :'border border-muted text-muted-foreground hover:text-cream'
              }`}
            >
              {cls.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}